<template>
  <div class="hidden-sm-and-down">
    <v-col cols="12" md="12" class="py-1">
      <v-card class="premium-card" max-width="300">
        <v-card-text class="pa-3">
          <p class="pa-2 mb-2 section-title">Your Followers</p>
          <v-list class="pa-0">
            <v-list-item
              class="pa-1 mb-1 rounded-lg hover-item"
              v-for="item in items"
              :key="item.name"
            >
              <v-list-item-avatar>
                <v-avatar size="42" class="elevation-1">
                  <img :src="item.image" alt="Profile picture" />
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span style="font-size: 13px; font-weight: 600">
                    {{ item.name }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span style="font-size: 11px">{{ item.level }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div class="text-center mt-2">
            <v-btn small color="#f69227" class="text-capitalize" text>
              <v-icon small left>mdi-account-group</v-icon>
              View All
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="py-1">
      <v-card class="premium-card" max-width="300">
        <v-list class="pa-1">
          <v-list-item class="rounded-lg hover-item">
            <v-list-item-avatar class="pa-0 ma-0">
              <v-icon color="#f69227">mdi-gift-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              <span style="font-size: 13px">Invite Friends</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="rounded-lg hover-item" to="/settings">
            <v-list-item-avatar class="ma-0">
              <v-icon color="#707070">mdi-cog-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              <span style="font-size: 13px">Settings</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="rounded-lg hover-item" @click="confirmLogout">
            <v-list-item-avatar class="ma-0">
              <v-icon color="#ef5350">mdi-logout</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              <span style="font-size: 13px; color: #ef5350">Sign Out</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>

    <!-- Logout Confirmation Dialog -->
    <v-dialog v-model="logoutDialog" max-width="340" persistent>
      <v-card class="premium-card pa-2">
        <v-card-title class="text-h6" style="font-size: 18px !important">
          <v-icon left color="#ef5350">mdi-logout</v-icon>
          Sign Out
        </v-card-title>
        <v-card-text class="pb-2">
          Are you sure you want to sign out of janguAsk?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="logoutDialog = false" class="text-capitalize">Cancel</v-btn>
          <v-btn color="#ef5350" dark rounded @click="logout" class="text-capitalize px-4">
            Sign Out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    logoutDialog: false,
    items: [
      {
        name: "Umar Abubakar",
        level: "Secondary",
        image: "https://randomuser.me/api/portraits/men/45.jpg",
      },
      {
        name: "Ibrahim Sani",
        level: "University",
        image: "https://randomuser.me/api/portraits/men/67.jpg",
      },
      {
        name: "Aisha Mohammed",
        level: "Primary",
        image: "https://randomuser.me/api/portraits/women/52.jpg",
      },
      {
        name: "Muhammad Bello",
        level: "Secondary",
        image: "https://randomuser.me/api/portraits/men/36.jpg",
      },
    ],
  }),
  methods: {
    confirmLogout() {
      this.logoutDialog = true;
    },
    logout() {
      this.logoutDialog = false;
      this.$root.store.logout();
      this.$root.showSnackbar(
        "You have been signed out successfully",
        "#333",
        "mdi-check-circle"
      );
      setTimeout(() => {
        this.$router.push("/login");
      }, 600);
    },
  },
};
</script>

<style scoped>
.hover-item {
  transition: background-color 0.2s ease;
}
.hover-item:hover {
  background-color: #f8f8f8;
}
</style>
